import { __assign } from "tslib";
import React from 'react';
/**
 * @function hocify
 * from hook to HOC.
 * Consume your hook output using HOC to support class components.
 * @param useHook - a custom hook as usual.
 * @returns An HOC to wrap your class component with to get the hook's output via props:
 */
export var hocify = function (useHook) { return function (Component) {
    var Wrapped = function (props) {
        var injectedProps = useHook();
        var combinedProps = __assign(__assign({}, props), injectedProps);
        return React.createElement(Component, __assign({}, combinedProps));
    };
    return Wrapped;
}; };
//# sourceMappingURL=hocify.js.map